module.exports = {"411527001":"顺河街道","411527002":"滨湖街道","411527003":"栏杆街道","411527004":"桂花街道","411527101":"马集镇","411527103":"防胡镇","411527104":"新里镇","411527105":"期思镇","411527106":"赵集镇","411527200":"淮滨县台头乡","411527201":"王家岗乡","411527202":"固城乡","411527203":"三空桥乡","411527204":"张里乡","411527206":"邓湾乡","411527207":"张庄乡","411527208":"王店乡","411527209":"淮滨县谷堆乡","411527212":"芦集乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411527.json
// module id = 1526
// module chunks = 0